<p8-settings-page>
  <p8-settings-header [titlePath]="['Images', 'Ajouter images']"></p8-settings-header>

  <div class="p8-bdc_image-new__container">
    <p8-file-picker #filePicker [(files)]="files" [accept]="'.jpg,.jpeg,.png,.gif'"></p8-file-picker>
    <div class="p8-secondary p8-bdc_image-new__help-text"  *ngIf="files.length === 0">
      Aucune image n'a été selectionnée
    </div>

    <div *ngFor="let file of files; index as i">
      <div class="p8-bdc_image-new__block-container">
        <!--<pre>{{file|json}}</pre>-->
        <p8-bdc-image-form [file]="file"></p8-bdc-image-form>

        <div class="p8-bdc_image-new__buttons-container p8-secondary" fxLayout="row">
          <button mat-icon-button (click)="remove(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <button mat-raised-button
            color="accent"
            class="p8-bdc_image-new__select-button"
            (click)="filePicker.click()"
    >
      CHOISISSEZ DEPUIS VOTRE ORDINATEUR
    </button>

  </div>
  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            [disabled]="!isValid()"
            (click)="onSubmit()">AJOUTER IMAGES</button>
    <button mat-button (click)="onCancel()">ANNULER</button>
  </p8-settings-footer>
</p8-settings-page>
